<template>
  <div class="pc_introduction">
    <div class="download_area" :class="{nuts: IS_NUTS}">
      <div class="inside">
        <div class="download_text">{{ $t('register.LAB_PLAY_BEST') }}</div>
        <div class="download_text" style="margin-bottom: 0.5rem">
          {{ $t('register.LAB_BE_MORE') }}
        </div>
        <download-button />
      </div>
    </div>
    <div class="afterDownload" v-if="siteType.GetSiteType() != siteType.SITE_TYPE_NUTS">
      <div class="swiper-container">
        <single-swiper :isPagination="false" :imageList="pcImages" swiperWidth="99%" imageWidth="100%" :swiperOptions="{
          slidesPerView: 4,
          spaceBetween: 0
        }" :key="keyNumber" />
      </div>
      <div class="club">
        <div class="divide-line"></div>
        <div class="poker-con">
          <div class="poker-item">
            <img class="picture" src="/static/img/home/pc/image_75.png?t=20240611" alt />
            <div class="text">
              <div class="primary_color poker-item-title1" v-text="$t('register.LAB_ENJOY')">
              </div>
              <div class="poker-item-con">
                <p class="sub_title">{{ $t('register.LAB_MORE') }}</p>
                <p class="sub_text">{{ $t('register.LAB_PLAY_GAME') }}</p>
                <p class="sub_text">{{ $t('register.LAB_MODE') }}</p>
                <p class="sub_text">{{ $t('register.LAB_TODAY') }}</p>
              </div>
            </div>
          </div>
          <div class="divide-line"></div>
          <div class="poker-item">
            <img class="picture" src="/static/img/home/pc/image_76.png" alt />
            <div class="text" style="margin-left: auto">
              <div class="primary_color poker-item-title2" v-text="$t('register.LAB_ACTION')">
              </div>
              <div class="poker-item-con">
                <p class="sub_title">{{ $t('register.LAB_MASTER') }}</p>
                <p class="sub_text">{{ $t('register.LAB_SAME_TIME') }}</p>
                <p class="sub_text">{{ $t('register.LAB_SWIPE') }}</p>
              </div>
            </div>
          </div>
          <div class="divide-line"></div>
          <div class="poker-item">
            <img class="picture" src="/static/img/home/pc/image_77.png" alt />
            <div class="text">
              <div class="primary_color poker-item-title3" v-text="$t('register.LAB_SAFE')">
              </div>
              <div class="poker-item-con">
                <p class="sub_title">{{ $t('register.LAB_ASSEM') }}</p>
                <p class="sub_text">{{ $t('register.LAB_RULES') }}</p>
                <p class="sub_text">{{ $t('register.LAB_TABLES') }}</p>
                <p class="sub_text">{{ $t('register.LAB_EVERY_DAY') }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!--    &lt;!&ndash; olakk hide more-player & club &ndash;&gt;-->
    <!--    <transition name="van-slide-up">-->
    <!--      <div v-show="showFloat" class="float_bottom" :style="{ backgroundImage: backgroundFooterImage}">-->
    <!--        <div @click="to_download" class="download_btn"></div>-->
    <!--        <div @click="showFloat = false" class="close"></div>-->
    <!--      </div>-->
    <!--    </transition>-->
  </div>
</template>

<script>
import SingleSwiper from '@/components/SwiperComponent/SingleSwiper.vue'
import downloadButton from '@/components/downloadButton.vue'
import { uploadTrack } from '../configs/userStatsTrack'
import { getUspData } from '@/configs/register'
import siteType from '../configs/siteType'

export default {
  name: 'pcRegister',
  components: {
    downloadButton,
    SingleSwiper
  },
  data () {
    return {
      keyNumber: 1,
      siteType
    }
  },
  mounted () {
    this.$nextTick(() => {
      setTimeout(() => {
        this.keyNumber++
      }, 1000)
    })
  },
  computed: {
    pcImages () {
      return getUspData(this.$i18n.locale, this.globalConfig, false)
    }
  },
  methods: {
    track (deviceType) {
      const category = 'SignUp PC'
      this.$gtag.event('Click', {
        event_category: category,
        event_label: `Download ${deviceType}`
      })
      // upload track data to aliyun
      uploadTrack(this)
    }
  }
}
</script>

<style lang="less" scoped>
.pc_introduction {
  background-color: #0a0a0a;

  .download_area {
    background: rgba(31, 157, 86, 1);
    height: 5.7rem;
    box-shadow: inset 0px -2px 0px rgba(255, 255, 255, 0.15),
      inset 0px 2px 0px rgba(255, 255, 255, 0.25);
    display: flex;
    justify-content: center;
    align-items: center;
    &.nuts {
      background: rgba(149, 121, 68, 1);
    }

    .inside {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: space-around;
    }

    .download_icon {
      width: 3.55rem;
      margin: 0 0.2rem;
    }

    .download_text {
      font-size: 0.666rem;
      color: #ffffff;
      line-height: 1.5rem;
      text-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25),
        0px 1px 10px rgba(30, 106, 70, 0.5);
      font-family: 'Oswald';
      font-style: normal;
      font-weight: 700;
    }
  }

  .afterDownload {
    width: 19rem;
    margin: auto;

    .poker-item {
      position: relative;
      width: 100%;

      // width: 19rem;
      min-height: 11rem;

      .picture {
        position: absolute;
      }

      .text {
        // position: absolute;
        width: 9.1rem;
      }
    }

    .primary_color {
      position: relative;
      font-size: 0.95rem;
      font-weight: 700;
      line-height: 1.17rem;
      white-space: pre-line;
    }

    .poker-item-con {
      position: relative;
      color: #ffffff;
      font-family: 'PingFang SC';
      font-weight: 900;
      font-size: 0.47rem;
      line-height: 0.7rem;
      margin-top: 0.6rem;

      .sub_title {
        font-weight: 900;
        font-size: 0.47rem;
        line-height: 0.7rem;
      }

      .sub_text {
        margin-top: 0.31rem;
        font-weight: 400;
        font-size: 0.35rem;
        line-height: 0.54rem;
      }
    }
  }
}
</style>
